import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '../../../components_base/CircularProgress';

function TermsOfUseView() {
  const { t, i18n } = useTranslation('components');
  return (
    <div className="gx-main-content-wrapper">
      <div className="ant-row">

        <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24">
          <div className="ant-row">
            <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24">
              <h1 className="title gx-mb-4">
                <span>{t('terms_of_use')}</span>
              </h1>
            </div>
          </div>

        </div>
        <div className="ant-card gx-card-widget gx-card-profile ant-card-bordered">
          <div className="ant-card-body">
            <div className="ant-card-head">
              <span className="ant-card-head-title gx-mb-2" />
              <p className="gx-text-grey gx-fs-sm gx-mb-0" />
            </div>
            <h3 className="gx-font-weight-light">
1. Introduction
            </h3>
            <p />
            <ul className="gx-list ant-list">
              <li className="gx-pb-1">1.1 These terms and conditions shall govern your use of our website.</li>
              <li className="gx-pb-1">
1.2 By using our website, you accept these terms and conditions in full;
              accordingly, if you disagree with these terms and conditions or any part of these terms and conditions,
              you must not use our website.
              </li>
              <li className="gx-pb-1">
1.3 If you [register with our website, submit any material to our website or use any
              of our website services], we will ask you to expressly agree to these terms and conditions.
              </li>
              <li className="gx-pb-1">
1.4 You must be at least [18] years of age to use our website; by using our website
              or agreeing to these terms and conditions, you warrant and represent to us that you are at least [18]
              years of age.
              </li>
              <li className="gx-pb-1">
1.5 Our website uses cookies; by using our website or agreeing to these terms and
              conditions, you consent to our use of cookies in accordance with the terms of our [privacy and cookies
              policy].
              </li>

            </ul>
            <p />
            <h3 className="gx-font-weight-light">2. Credit</h3>
            <ul className="gx-list ant-list">
              <li className="gx-pb-1">
2.1 This document was created using a template from SEQ Legal ( HYPERLINK
              "http://www.seqlegal.com/"http://www.seqlegal.com).
              </li>
            </ul>

            <p>
You must retain the above credit. Use of this document without the credit is an infringement of copyright.
            However, you can purchase from us an equivalent document that does not include the credit.
            </p>
            <p />
            <h3 className="gx-font-weight-light">3. Copyright notice</h3>
            <ul className="gx-list ant-list">
              <li className="gx-pb-1">3.1 Copyright (c) [year(s) of first publication] [full name].</li>
              <li className="gx-list ant-list">
3.2 Subject to the express provisions of these terms and conditions:
                <ul>
                  <li>
(a) we, together with our licensors, own and control all the copyright and other intellectual
                  property rights in our website and the material on our website; and
                  </li>
                  <li>
(b) all the copyright and other intellectual property rights in our website and the material on our
                  website are reserved.
                  </li>
                </ul>
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">4. Licence to use website</h3>
            <ul>
              <li className="gx-list ant-list">
              4.1 You may:
                <ul>
                  <li>(a) view pages from our website in a web browser;</li>
                  <li>(b) download pages from our website for caching in a web browser;</li>
                  <li>(c) print pages from our website;</li>
                  <li>(d) [stream audio and video files from our website]; and</li>
                  <li>
(e) [use [our website services] by means of a web browser], subject to the other provisions of these
                  terms and conditions.
                  </li>
                </ul>
              </li>
              <li className="gx-list ant-list">
4.2 Except as expressly permitted by Section 4.1 or the other provisions of
              these terms and conditions, you must not download any material from our website or save any such material
              to your computer.
              </li>
              <li className="gx-list ant-list">
4.3 You may only use our website for [your own personal and business
              purposes], and you must not use our website for any other purposes.
              </li>
              <li className="gx-list ant-list">
4.4 Except as expressly permitted by these terms and conditions, you must
              not edit or otherwise modify any material on our website.
              </li>
              <li className="gx-list ant-list">
              4.5 Unless you own or control the relevant rights in the material, you must not:
                <ul>
                  <li>(a) republish material from our website (including republication on another website);</li>
                  <li>(b) sell, rent or sub-license material from our website;</li>
                  <li>(c) show any material from our website in public;</li>
                  <li>(d) exploit material from our website for a commercial purpose; or</li>
                  <li>(e) redistribute material from our website.</li>

                </ul>
              </li>
              <li className="gx-list ant-list">
4.6 Notwithstanding Section 4.5, you may redistribute [our newsletter] in
              [print and electronic form] to [any person].
              </li>
              <li className="gx-list ant-list">
4.7 We reserve the right to restrict access to areas of our website, or
              indeed our whole website, at our discretion; you must not circumvent or bypass, or attempt to circumvent
              or bypass, any access restriction measures on our website.
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">
5. Acceptable use
            </h3>
            <ul>
              <li className="gx-list ant-list">
              5.1 You must not:
                <ul>
                  <li>
(a) use our website in any way or take any action that causes, or may cause, damage to the website
                  or impairment of the performance, availability or accessibility of the website;
                  </li>
                  <li>
                  (b) use our website in any way that is unlawful, illegal, fraudulent or harmful, or in connection with
                  any unlawful, illegal, fraudulent or harmful purpose or activity;
                  </li>
                  <li>
(c) use our website to copy, store, host, transmit, send, use, publish or distribute any material
                  which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger,
                  rootkit or other malicious computer software;
                  </li>
                  <li>
(d) [conduct any systematic or automated data collection activities (including without limitation
                  scraping, data mining, data extraction and data harvesting) on or in relation to our website without
                  our express written consent];
                  </li>
                  <li>
(e) [access or otherwise interact with our website using any robot, spider or other automated
                  means[, except for the purpose of [search engine indexing]]];
                  </li>
                  <li>(f) [violate the directives set out in the robots.txt file for our website]; or</li>
                  <li>
(g) [use data collected from our website for any direct marketing activity (including without
                  limitation email marketing, SMS marketing, telemarketing and direct mailing)].
                  </li>
                  <li>[additional list items]</li>
                </ul>
              </li>
              <li className="gx-list ant-list">
5.2 You must not use data collected from our website to contact
              individuals, companies or other persons or entities.
              </li>
              <li className="gx-list ant-list">
5.3 You must ensure that all the information you supply to us through our
              website, or in relation to our website, is [true, accurate, current, complete and non-misleading].
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">
6. Registration and accounts
            </h3>
            <ul>
              <li className="gx-list ant-list">
6.1 To be eligible for [an account] on our website under this Section 6,
              you must [be resident or situated in the United Kingdom].
              </li>
              <li className="gx-list ant-list">
6.2 You may register for an account with our website by [completing and
              submitting the account registration form on our website, and clicking on the verification link in the
              email that the website will send to you].
              </li>
              <li className="gx-list ant-list">
6.3 You must not allow any other person to use your account to access the
              website.
              </li>
              <li className="gx-list ant-list">
6.4 You must notify us in writing immediately if you become aware of any
              unauthorised use of your account.
              </li>
              <li className="gx-list ant-list">
6.5 You must not use any other person's account to access the website[,
              unless you have that person's express permission to do so].
              </li>

            </ul>
            <h3 className="gx-font-weight-light">
7. User login details
            </h3>
            <ul>
              <li className="gx-list ant-list">
7.1 If you register for an account with our website, [we will provide you
              with] OR [you will be asked to choose] [a user ID and password].
              </li>
              <li className="gx-list ant-list">
              7.2 Your user ID must not be liable to mislead and must comply with the content rules set out in Section
              10; you must not use your account or user ID for or in connection with the impersonation of any person.
              </li>
              <li className="gx-list ant-list">
              7.3 You must keep your password confidential.
              </li>
              <li className="gx-list ant-list">
              7.4 You must notify us in writing immediately if you become aware of any disclosure of your password.
              </li>
              <li className="gx-list ant-list">
              7.5 You are responsible for any activity on our website arising out of any failure to keep your password
              confidential, and may be held liable for any losses arising out of such a failure.

              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">
8. Cancellation and suspension of account
            </h3>
            <ul>
              <li className="gx-list ant-list">
8.1 We may:
                <ul>
                  <li>(a) [suspend your account];</li>
                  <li>
(b) [cancel your account]; and/or
                  </li>
                  <li>
                  (c) [edit your account details],
                  </li>
                  <li>at any time in our sole discretion without notice or explanation.</li>
                </ul>
              </li>
              <li className="gx-list ant-list">
8.2 You may cancel your account on our website [using your account control
              panel on the website].
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">
9. Your content: licence
            </h3>
            <ul>
              <li className="gx-list ant-list">
9.1 In these terms and conditions, "your content" means [all works and
              materials (including without limitation text, graphics, images, audio material, video material,
              audio-visual material, scripts, software and files) that you submit to us or our website for storage or
              publication on, processing by, or transmission via, our website].
              </li>
              <li className="gx-list ant-list">
9.2 You grant to us a [worldwide, irrevocable, non-exclusive, royalty-free
              licence] to [use, reproduce, store, adapt, publish, translate and distribute your content in any existing
              or future media] OR [reproduce, store and publish your content on and in relation to this website and any
              successor website] OR [reproduce, store and, with your specific consent, publish your content on and in
              relation to this website].
              </li>
              <li className="gx-list ant-list">
9.3 You grant to us the right to sub-license the rights licensed under
              Section 9.2.
              </li>
              <li className="gx-list ant-list">
9.4 You grant to us the right to bring an action for infringement of the
              rights licensed under Section 9.2.
              </li>
              <li className="gx-list ant-list">
9.5 You hereby waive all your moral rights in your content to the maximum
              extent permitted by applicable law; and you warrant and represent that all other moral rights in your
              content have been waived to the maximum extent permitted by applicable law.
              </li>
              <li className="gx-list ant-list">
9.6 You may edit your content to the extent permitted using the editing
              functionality made available on our website.
              </li>
              <li className="gx-list ant-list">
9.7 Without prejudice to our other rights under these terms and conditions,
              if you breach any provision of these terms and conditions in any way, or if we reasonably suspect that you
              have breached these terms and conditions in any way, we may delete, unpublish or edit any or all of your
              content.
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">
10. Your content: rules
            </h3>
            <ul>
              <li className="gx-list ant-list">
10.1 You warrant and represent that your content will comply with these
              terms and conditions.
              </li>
              <li className="gx-list ant-list">
10.2 Your content must not be illegal or unlawful, must not infringe any
              person's legal rights, and must not be capable of giving rise to legal action against any person (in each
              case in any jurisdiction and under any applicable law).
              </li>
              <li className="gx-list ant-list">
10.3 Your content, and the use of your content by us in accordance with
              these terms and conditions, must not:
                <ul>
                  <li>(a) be libellous or maliciously false;</li>
                  <li>
(b) be obscene or indecent;
                  </li>
                  <li>
(c) infringe any copyright, moral right, database right, trade mark right, design right, right in
                  passing off, or other intellectual property right;
                  </li>
                  <li>
(d) infringe any right of confidence, right of privacy or right under data protection legislation;
                  </li>
                  <li>(e) constitute negligent advice or contain any negligent statement;</li>
                  <li>
(f) constitute an incitement to commit a crime[, instructions for the commission of a crime or the
                  promotion of criminal activity];
                  </li>
                  <li>
(g) be in contempt of any court, or in breach of any court order;
                  </li>
                  <li>(h) be in breach of racial or religious hatred or discrimination legislation;</li>
                  <li>(i) be blasphemous;</li>
                  <li>(j) be in breach of official secrets legislation;</li>
                  <li>(k) be in breach of any contractual obligation owed to any person;</li>
                  <li>(l) [depict violence[ in an explicit, graphic or gratuitous manner]];</li>
                  <li>
(m) [be pornographic[, lewd, suggestive or sexually explicit]];
                  </li>
                  <li>(n) [be untrue, false, inaccurate or misleading];</li>
                  <li>
(o) [consist of or contain any instructions, advice or other information which may be acted upon and
                  could, if acted upon, cause illness, injury or death, or any other loss or damage];
                  </li>
                  <li>(p) [constitute spam];</li>
                  <li>
(q) [be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing,
                  hateful, discriminatory or inflammatory]; or
                  </li>
                  <li>(r) [cause annoyance, inconvenience or needless anxiety to any person].</li>
                  <li>[additional list items]</li>
                </ul>
              </li>
            </ul>
            <p />
            <h3 className="gx-font-weight-light">11. Limited warranties</h3>
            <ul>
              <li className="gx-list ant-list">
11.1 We do not warrant or represent:
                <ul>
                  <li>
(a) the completeness or accuracy of the information published on our website;
                  </li>
                  <li>(b) that the material on the website is up to date; or</li>
                  <li>(c) that the website or any service on the website will remain available.</li>
                </ul>
              </li>
              <li className="gx-list ant-list">
11.2 We reserve the right to discontinue or alter any or all of our website
              services, and to stop publishing our website, at any time in our sole discretion without notice or
              explanation; and save to the extent expressly provided otherwise in these terms and conditions, you will
              not be entitled to any compensation or other payment upon the discontinuance or alteration of any website
              services, or if we stop publishing the website.
              </li>
              <li className="gx-list ant-list">
11.3 To the maximum extent permitted by applicable law and subject to
              Section 12.1, we exclude all representations and warranties relating to the subject matter of these terms
              and conditions, our website and the use of our website.
              </li>

            </ul>
            <p />
            <h3 className="gx-font-weight-light">12. Limitations and exclusions of liability</h3>
            <ul>
              <li className="gx-list ant-list">
12.1 Nothing in these terms and conditions will:
                <ul>
                  <li>
(a) limit or exclude any liability for death or personal injury resulting from negligence;
                  </li>
                  <li>(b) limit or exclude any liability for fraud or fraudulent misrepresentation;</li>
                  <li>(c) limit any liabilities in any way that is not permitted under applicable law; or</li>
                  <li>
(d) exclude any liabilities that may not be excluded under applicable law.
                  </li>
                </ul>
              </li>
              <li className="gx-list ant-list">
12.2 The limitations and exclusions of liability set out in this Section 12
              and elsewhere in these terms and conditions:
                <ul>
                  <li>(a) are subject to Section 12.1; and</li>
                  <li>
(b) govern all liabilities arising under these terms and conditions or relating to the subject
                  matter of these terms and conditions, including liabilities arising in contract, in tort (including
                  negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in
                  these terms and conditions.
                  </li>
                </ul>
              </li>
              <li className="gx-list ant-list">
12.3 To the extent that our website and the information and services on our
              website are provided free of charge, we will not be liable for any loss or damage of any nature.
              </li>
              <li className="gx-list ant-list">
12.4 We will not be liable to you in respect of any losses arising out of
              any event or events beyond our reasonable control.
              </li>
              <li className="gx-list ant-list">
12.5 We will not be liable to you in respect of any business losses,
              including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated
              savings, business, contracts, commercial opportunities or goodwill.
              </li>
              <li className="gx-list ant-list">
12.6 We will not be liable to you in respect of any loss or corruption of
              any data, database or software.
              </li>
              <li className="gx-list ant-list">
12.7 We will not be liable to you in respect of any special, indirect or
              consequential loss or damage.
              </li>
              <li className="gx-list ant-list">
12.8 You accept that we have an interest in limiting the personal liability
              of our officers and employees and, having regard to that interest, you acknowledge that we are a limited
              liability entity; you agree that you will not bring any claim personally against our officers or employees
              in respect of any losses you suffer in connection with the website or these terms and conditions (this
              will not, of course, limit or exclude the liability of the limited liability entity itself for the acts
              and omissions of our officers and employees).
              </li>
            </ul>
            <p />

          </div>

        </div>
      </div>
    </div>
  );
}

export default () => {
  return (
    <Suspense fallback={<CircularProgress />}>
      <TermsOfUseView />
    </Suspense>
  )
};
